export default __webpack_public_path__ + "static/media/2.c26546c1.jpg";